import { render, staticRenderFns } from "./EditPane.vue?vue&type=template&id=67277ac0&scoped=true"
import script from "./EditPane.vue?vue&type=script&lang=js"
export * from "./EditPane.vue?vue&type=script&lang=js"
import style0 from "./EditPane.vue?vue&type=style&index=0&id=67277ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67277ac0",
  null
  
)

export default component.exports